import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'
import { useParams } from 'react-router-dom'

const TeamEvent = () => {
  const { team, guild } = useTeam()
  const { eventId } = useParams()

  return (
    <Section title={`Event | ${team.name} | ${guild.name}`}>
      TeamEvent! {team.id} - {eventId}
    </Section>
  )
}

export default TeamEvent
